export default {"src":"/_next/static/media/ppa-points-icon.b058035f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};